<template>
  <div class="h5_login">
    <div class="pic_box">
      <img src="../../../assets/img/h5_login.png" alt />
    </div>
    <div class="input_wrapper">
      <van-dropdown-menu class="selectWrapper">
        <van-dropdown-item v-model="value" :options="option1" />
      </van-dropdown-menu>
      <div class="desc">{{$t('h5.phone')}}</div>
      <van-cell-group class="groupWrapper" inset>
        <van-field v-model="tel" type="tel" :placeholder="$t('h5.phoneDesc')" />
      </van-cell-group>
      <div class="desc">{{$t('h5.verification')}}</div>
      <van-cell-group class="groupWrapper" inset>
        <van-field v-model="sms" center clearable l :placeholder="$t('h5.passWordeDesc')" >
          <template #button>
            <van-button size="small" @click="sendMsg" type="primary">{{$t('h5.send')}}</van-button>
          </template>
        </van-field>
      </van-cell-group>
      <!-- <van-field class="userAccount"  v-model="userId" :label="$t('other.a1785')" :placeholder="$t('other.a3186')"/>
      <van-field class="userAccount"  v-model="password" type="password" :label="$t('other.a3185')"  :placeholder="$t('other.a1754')"/>-->
    </div>
    <div class="language">
      <van-radio-group v-model="checked" @change="setLanguage" direction="horizontal">
        <van-radio name="zh">CN</van-radio>
        <van-radio name="en">EN</van-radio>
      </van-radio-group>
    </div>
    <van-button class="btn" type="info" @click="singIn()">{{$t('h5.login')}}</van-button>
  </div>
</template>

<script>
import api from "../../../api/api";
import newOrders from "../../../api/moudles/newOrders";
import md5 from "js-md5";
export default {
  data() {
    return {
      checked: "en",
      password: null,
      userId: null,
      tel: null,
      sms: null,
      value: "+60",
      option1: [
        {
          value: "+86",
          text: "China(+86)"
        },
        {
          value: "+63",
          text: "Philippines(+63)"
        },
        {
          value: "+65",
          text: "Singapore(+65)"
        },
        {
          value: "+84",
          text: "Vietnam(+84)"
        },
        {
          value: "+60",
          text: "Malaysia(+60)"
        },
        {
          value: "+34",
          text: "Spain(+34)"
        },
        {
          value: "+62",
          text: "Indonesia(+62)"
        },
        {
          value: "+66",
          text: "Thailand(+66)"
        },
        {
          value: "+351",
          text: "Portugal(+Portugal)"
        },
        {
          value: "+886",
          text: "Taiwan(+886)"
        }
      ]
    };
  },
  inject:['reload'],
  created() {},
  methods: {
    toRegister() {
      this.$router.push({
        path: "/mh5/register",
        query: {
          invitationCode: this.$route.query.invitationCode
        }
      });
    },

    sendMsg() {
        if(!this.tel){
            this.$toast({
                message: this.$t('other.a438'),
                position: "center"
              });
        }
      newOrders
        .getLoginByPhoneCode({
          country: this.value,
          phone: this.tel
        })
        .then(res => {
          if (res.code === 200) {
            if (res.data == "账户余额不足") {
              this.$toast({
                message: this.$t('other.a455'),
                position: "center"
              });
            } else {
              this.$toast({
                message: this.$t('other.a440'),
                position: "center"
              });
            }
            this.countDown();
          } else {
            this.$message.warning(res.msg);
            this.countDown();
          }
        });
    },

    singIn() {
      if (!this.sms || !this.tel) {
        this.$toast({
          message: this.$t('other.a1710'),
          position: "center"
        });
        return;
      }

      const params = {
        code: this.sms,
        userId: this.tel
      };

      newOrders.getLoginInfo(params).then(res => {
        if (res.code === 200) {
          console.log("desc", res.data);
          if (res.code === 200) {
            this.$toast.success(this.$t('other.a1711'));
            localStorage.setItem("userInfo", JSON.stringify(res.data));
            setTimeout(() => {
              let pathUrl="/mh5/index"
              let params={
                invitationCode: this.$route.query.invitationCode
              }
              if(this.$route.query.from === 'detail'){
                pathUrl="/mh5/detail"
                params.groupId=this.$route.query.groupId,
                  params.productId = this.$route.query.productId
              }
              this.$router.push({
                path: pathUrl,
                query: params
              });
            }, 300);
          } else {
            this.$toast({
              message: res.msg,
              position: "center"
            });
          }
        } else {
          this.$message.warning(res.msg);
        }
      });
    },

    setLanguage(){

        console.log(this.checked)
        
        localStorage.setItem('lang', this.checked)
        this.$i18n.locale =  this.checked 
				this.reload()
    },
  }
};
</script>
<style lang="scss" scoped>
.h5_login {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  .userAccount {
    margin: 10px 0;
  }

  .language {
    width: 50%;
    margin: 2rem 0;
  }

  .desc {
    font-size: 16px;
    font-weight: bold;
    padding: 0.5rem 0.7rem;
  }

  .selectWrapper {
    margin-bottom: 3rem;
  }

  .input_wrapper {
    margin-top:3rem;
  }

  .pic_box {
    width: 8rem;
    height: 0;
    padding-bottom: 8rem;
    overflow: hidden;

    img {
      width: 100%;
    }
  }

  .btn {
    width: 10rem;
    margin-top: 2rem;
  }

  .registore {
    font-size: 0.6rem;
    margin-top: 10px;
    color: #1989fa;
  }
}
</style>